import { cn } from "../lib/utils";

/**
 * Barra de progresso.
 *
 * O preenchimento é magenta por padrão porque o uso original é PROGRESSO — a
 * regra de uma voz só do DESIGN.md reserva o magenta para ação, seleção e
 * avanço. `indicatorClassName` existe para o outro uso, a MEDIÇÃO (precisão,
 * fluência), que fala em `feedback-*`: pintar uma nota de magenta diria que a
 * nota é progresso, e ainda gastaria a única cor de ação da tela.
 */
export function ProgressBar({
  value,
  label,
  className,
  indicatorClassName,
}: {
  value: number;
  label: string;
  className?: string;
  indicatorClassName?: string;
}) {
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value}
      className={cn(
        "h-1.5 overflow-hidden rounded-full bg-neutral-100",
        className,
      )}
    >
      <div
        className={cn("h-full rounded-full bg-brand-700", indicatorClassName)}
        style={{ width: `${value}%` }}
      />
    </div>
  );
}
